import Vote from './index';
import VoteBatch from './Batch';
import VoteCoin from './Coin';

export default {
  path: '/home/vote',
  component: Vote,
  children: [
    { path: '/home/vote/batchSetting', component: VoteBatch },
    { path: '/home/vote/coinSetting', component: VoteCoin }
  ]
};
